import React from 'react';
import AddToPlanCard from './AddToPlanCard';
import { useLacksEntitlement } from '../contexts/EntitlementsContext';
import { TruckIcon, BuildingIcon, RepeatIcon } from './icons/LucideIcons';

/**
 * Storefront-shop features the Studio plan does not include (Studio slice S2).
 * One card per entitlement key; the pages, settings tabs and customer tabs
 * that belong to a feature wrap themselves in <PlanFeatureGate feature=…>.
 */
export const FEATURE_CARDS = {
  dispatch: {
    icon: TruckIcon,
    title: "Dispatch & drivers aren't part of this plan",
    body: 'The dispatch map, Smart Routing, the driver app, delivery photos and Scan Station come with the Core plan.',
  },
  house_accounts: {
    icon: BuildingIcon,
    title: "House accounts aren't part of this plan",
    body: 'Billing customers on account, with invoices and statements, comes with the Core plan.',
  },
  recurring_orders: {
    icon: RepeatIcon,
    title: "Recurring orders aren't part of this plan",
    body: 'Standing weekly and monthly orders that create themselves come with the Core plan.',
  },
};

/**
 * Renders children unless the shop is KNOWN to lack `feature`; then the
 * "Add to your plan" card (or `fallback`, e.g. null for a secondary block
 * next to one that already shows the card). While the list is loading, or
 * for staff whose list could not be read, nothing changes: the API answers
 * 403 on its own, so this never has to guess.
 */
const PlanFeatureGate = ({ feature, fallback, children }) => {
  const lacks = useLacksEntitlement(feature);
  if (!lacks) return children;
  if (fallback !== undefined) return fallback;
  const card = FEATURE_CARDS[feature];
  const Icon = card && card.icon;
  return (
    <AddToPlanCard
      icon={Icon ? <Icon size={20} /> : null}
      title={card ? card.title : "This feature isn't part of this plan"}
      body={card ? card.body : null}
    />
  );
};

export default PlanFeatureGate;
